// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Cp77","label":"SetPasswdForm_label__yQvY1"};